import React from 'react';

export default function CardSummary({
  img = null,
  title = '',
  body = '',
  className = '',
  titleClassName = '',
  bodyClassName = '',
  loading = false,
  count = null,
  countLabel = 'Count',
  volumeValue = '',
  threshold = '',
}) {
  const transformedBody =
    !loading && typeof Number(body) === 'number' && !isNaN(body)
      ? Number(body).toLocaleString()
      : body;

  return (
    <article
      className={`${className} bg-white border py-4 px-6 border-[#E4E7EC] shadow-cards relative flex-wrap rounded-xl flex items-center gap-2 lg:flex-col lg:items-start xl:flex-row xl:items-start`}
    >
      {img ? <img src={img} alt="" width={40} height={40} /> : null}
      <div className="flex flex-col flex-wrap gap-4">
        <span
          className={`text-sm text-[#667185] font-medium ${titleClassName}`}
        >
          {title}
        </span>
        <span
          className={`font-semibold text-[32px] text-[#1D2739] ${bodyClassName}`}
        >
          {loading ? (
            <div className="mt-2">
              <div className="w-[90px] h-7 bg-[#e5e7eb] rounded animate-pulse"></div>
            </div>
          ) : (
            transformedBody
          )}
        </span>
        {volumeValue && (
          <span className="text-[14px]   text-[#868C98]">
            Volume:{' '}
            <span className="font-semibold text-[#0B1C56]">{volumeValue}</span>
          </span>
        )}{' '}
        {threshold && (
          <span className="text-[14px]   text-danger">
            Payment threshold:
            <span className="font-semibold text-danger ml-1">{threshold}</span>
          </span>
        )}{' '}
        {count !== undefined && count !== null && (
          <div className="absolute bottom-2 right-3 text-black text-[10px]">
            Count: <span className="ml-[2px] font-medium">{count}</span>
          </div>
        )}
      </div>
    </article>
  );
}
